import {gql} from "@apollo/client";

export const ProfileData = gql`
    query ProfileData {
        profile {
            id
            name
            firstName
            lastName
            email
            phone
            language
            timezone
            measurementSystem
            deletionRequestedAt
            roles {
                id
                name
                accessLevel
                description
                key
            }
        }
    }`